import {
  AlertTriangle,
  AtSign,
  Bell,
  CheckCircle2,
  PlugZap,
  Timer,
  UserPlus,
  Users,
  type LucideIcon,
} from "lucide-react";

/** Notificacao como o backend entrega (payload do socket e do GET). */
export interface AppNotification {
  id: string;
  type: string;
  title: string;
  body: string | null;
  link: string | null;
  metadata: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
}

/**
 * Aparencia por tipo. Tipo desconhecido cai no default — a UI nunca quebra por
 * um `type` novo vindo do backend antes de o frontend saber dele (o que vai
 * acontecer na Fase 3, quando os produtores entrarem).
 */
const APARENCIA: Record<string, { icone: LucideIcon; cor: string }> = {
  conversa_atribuida: { icone: UserPlus, cor: "text-blue-500" },
  conversa_transferida: { icone: Users, cor: "text-blue-500" },
  mencao: { icone: AtSign, cor: "text-violet-500" },
  massiva_detectada: { icone: AlertTriangle, cor: "text-amber-500" },
  // Encerramento usa o mesmo ícone da abertura, em verde: o atendente lê a dupla
  // "âmbar abriu / verde encerrou" sem precisar decorar dois símbolos.
  massiva_encerrada: { icone: AlertTriangle, cor: "text-emerald-500" },
  campanha_finalizada: { icone: CheckCircle2, cor: "text-emerald-500" },
  // Sem produtor ainda: falta decidir quantas falhas seguidas contam como
  // "fora do ar", senao notificaria a cada timeout isolado.
  erp_indisponivel: { icone: PlugZap, cor: "text-red-500" },
  // Vermelho como o ERP fora do ar, e pelo mesmo motivo: já quebrou. O canal
  // parou de receber mensagem e só volta com alguém no gerenciador da Meta (#325).
  canal_fora_do_ar: { icone: PlugZap, cor: "text-red-500" },
  // Supervisao de fila (gk-chat#178). Âmbar porque pede ação e ainda dá tempo —
  // vermelho fica reservado pro que já quebrou (ERP fora do ar).
  "queue-stalled": { icone: Timer, cor: "text-amber-500" },
  "chat-unassigned": { icone: UserPlus, cor: "text-amber-500" },
};

export function aparenciaDoTipo(type: string): { icone: LucideIcon; cor: string } {
  return APARENCIA[type] ?? { icone: Bell, cor: "text-muted-foreground" };
}
